import React from 'react';
import styled from 'styled-components';
import { Heading, Stack } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { colors, spaces, typography } from '@99designs/emu/settings';

const SVGTileWrapper = styled.div`
    position: relative;

    ${mediaQuery.minimum('medium')} {
        padding-bottom: 100%;
    }
`;

const SVGTileContents = styled.div`
    padding: ${spaces['1bu']};

    ${mediaQuery.minimum('medium')} {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;

const Items = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;

    > * {
        padding: 0 ${spaces['1bu']} 0 0;

        :last-child {
            padding: 0;
        }
    }

    ${mediaQuery.minimum('medium')} {
        flex-direction: column;
        justify-content: center;
        text-align: center;

        > * {
            padding: 0 0 ${spaces['1bu']} 0;

            :last-child {
                padding: 0;
            }
        }
    }
`;

const InlineSVG = styled.div`
    width: 25%;

    ${mediaQuery.minimum('medium')} {
        width: 45%;
    }
`;

const Text = styled.div<{ narrowText?: boolean }>`
    padding: 0 ${({ narrowText }) => (narrowText ? spaces['3bu'] : 0)};
`;

const Label = styled.div`
    color: ${colors.grey700};
    font-size: ${typography.typeScale.size1}px;
`;

interface Props {
    svg: string;
    title?: string;
    label?: string;
    narrowText?: boolean;
    largeText?: boolean;
}

export default function SVGTile(props: Props) {
    return (
        <SVGTileWrapper>
            <SVGTileContents>
                <Items>
                    <InlineSVG dangerouslySetInnerHTML={{ __html: props.svg }} />
                    <Stack space="0.5bu">
                        <Text narrowText={props.narrowText}>
                            <Heading accessibilityLevel={props.largeText ? 5 : 6} color="grey800">
                                {props.title}
                            </Heading>
                        </Text>
                        <Text narrowText={props.narrowText}>
                            <Label>{props.label}</Label>
                        </Text>
                    </Stack>
                </Items>
            </SVGTileContents>
        </SVGTileWrapper>
    );
}
